/*
  Находки реестра банкротств в ШАПКЕ карточки счёта - вариант Б и требование владельца
  27.10.2026: находка видна сразу, на любой вкладке, а не только на вкладке «Должники».

  Почему не внутри вкладки. Находка останавливает подачу по счёту, и человек, открывший
  карточку за приказом или за документами, обязан узнать об этом до того, как соберёт
  пакет, а не после отказа сервера. Тот же довод, по которому запрет обращаться стоит над
  вкладками (`ContactState`).

  Блока нет вовсе, пока по людям счёта нечего разбирать. Находки грузит сам блок: карточка
  счёта их не несёт. Решённая находка исчезает после перечитывания карточки (`version`).
*/

import { useEffect, useState } from 'react'

import { api } from '../api/client.js'
import { Notice } from './Common.jsx'
import RegistryFindingDecision from './RegistryFindingDecision.jsx'

// Находок у одного счёта единицы (по человеку на карточку реестра), но не десятки.
const LIMIT = 50

export default function AccountRegistryFindings({ accountId, version, onDone }) {
  const [items, setItems] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    api
      .registryFindings({ account_id: accountId, limit: LIMIT })
      .then((page) => {
        setItems(page.items)
        setError(null)
      })
      .catch(setError)
  }, [accountId, version])

  if (error) return <Notice error={error} wide />
  return items.map((finding) => (
    <RegistryFindingDecision key={finding.id} finding={finding} onDone={onDone} />
  ))
}
